import { render, staticRenderFns } from "./LinkedFieldsMediaLink.vue?vue&type=template&id=0e72bb2e&scoped=true&"
import script from "./LinkedFieldsMediaLink.vue?vue&type=script&lang=js&"
export * from "./LinkedFieldsMediaLink.vue?vue&type=script&lang=js&"
import style0 from "./LinkedFieldsMediaLink.vue?vue&type=style&index=0&id=0e72bb2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e72bb2e",
  null
  
)

export default component.exports